import r from '../utils/request'

// One-page account settings: subscription, card, receipts, closing the account

export const getBilling = () => r.get('/account/billing')

export const getInvoices = () => r.get('/account/invoices')

export const getInvoicePdf = (id) => r.get(`/account/invoices/${id}/pdf`)

export const cancelSubscription = () => r.post('/account/subscription/cancel')

export const resumeSubscription = () => r.post('/account/subscription/resume')

export const changePlan = (plan_id) => r.post('/account/subscription/change', { plan_id })

export const upgradeCheckout = (plan_id) => r.post('/account/subscription/checkout', { plan_id })

export const getPortalSession = () => r.post('/account/portal-session')

export const getCloseOptions = () => r.get('/account/close')

export const closeAccount = (params) => r.post('/account/close', params)

export const updateProfile = (params) => r.put('/users', params)

// Leave a group; keep_recipes: leave your recipes with the family (default)
export const leaveGroup = (id, params) => r.delete(`/groups/${id}/leave`, params)

// The API sends errors as { status: 'error', data: '...' } or data: '10024: ...'
export const apiError = (err, fallback) => {
  const data = err?.response?.data?.data
  if (typeof data === 'string' && data) return data.replace(/^\d+:\s*/, '')
  return fallback
}
